import React from 'react'
import { graphql, compose } from 'react-apollo'
import MarkNotificationReadMutation from './queries/MarkNotificationReadMutation'

class Notification extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props
    }
  }
  dismissNotification = () => {
    this.markAsRead()
    fetch(`/admin/loans/${this.state.loanId}/notes/${this.state.notificationId}/confirm_pipeline`, {
      method: 'PUT',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.props.csrfToken,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: `{ "notification_id": "${this.state.notificationId}", "loan_id": "${this.state.loanId}" }`,
      credentials: 'same-origin'
    })
    this.props.dismissNote(this.state.notificationId)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }

  markAsRead = async () => {
    const { notificationId, markNotificationRead } = this.props
    return await markNotificationRead({
      variables: {
        input: {
          notificationId,
          markAsRead: true
        }
      }
    })
  }

  render() {
    const { loanId, enableEdit, icon, formattedDate, description, dismissable } = this.state

    return (
      <div className='notification'>
        <div className={`icon ${icon.color}`}>
          <i className={`fa fa-${icon.image}`} />
        </div>
        <span dangerouslySetInnerHTML={{ __html: description }} />
        <div className='comment'>
          <i className='fa fa-circle' />
          <p>{formattedDate}</p>
        </div>
        { enableEdit && dismissable &&
          <div className='close-n'>
            <i className='fa fa-close' onClick={this.dismissNotification} />
          </div>
        }
      </div>
    )
  }
}

const NotificationWithQuery = compose(
  graphql(MarkNotificationReadMutation, {
    name: 'markNotificationRead'
  })
)(Notification)

export default NotificationWithQuery
